import {useContext} from 'react'

import {Hero} from '@primer/react-brand'

import {PlanTypeContext} from '../_context/PlanTypeContext'

import {PlanTypeSegmentedControl} from '../_components/PlanTypeSegmentedControl'

export default function HeroSection() {
  const {planType, setPlanType} = useContext(PlanTypeContext)

  return (
    <div className="position-relative">
      <Hero align="center" className="pb-4">
        <Hero.Heading size="2">
          Take flight with <span style={{whiteSpace: 'nowrap'}}>GitHub Copilot</span>
        </Hero.Heading>
      </Hero>

      <div className="d-flex flex-justify-center px-2 mb-7">
        <h2 className="visually-hidden" id="pricing-plans">
          Pricing plans
        </h2>

        <PlanTypeSegmentedControl value={planType} onChange={setPlanType} />
      </div>
    </div>
  )
}

try{ HeroSection.displayName ||= 'HeroSection' } catch {}